// To generate a new file similar to this one, run `pay js:run gql-v1 --type=lazy-query --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import type {
  V1LazyQueryOptions,
  V1LazyQueryOptionsWithoutVariables,
  V1LazyQueryReturn,
  AccountToken,
} from '@stripe-internal/data-v1/types';
import {gql} from '@sail/data';
import {useV1LazyQuery} from '@stripe-internal/data-v1';

import type {
  GraphQlDocument,
  GraphQlFragmentUnion,
  HookVariables,
} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  OpenapiGetV1CryptoInternalPayinSessionInput,
  V1ContextInput,
} from '@stripe-internal/data-v1/schema/types';

import {payinSessionFragment} from 'src/api/graphql/payinSessionFragment';

import type {
  PayinSessionFragmentData,
  PayinSessionFragmentToken,
} from 'src/api/graphql/payinSessionFragment';

const doc = gql`
  query PayinSessionLazyQuery(
    $input: OpenapiGetV1CryptoInternalPayinSessionInput
    $v1Context: V1ContextInput!
  ) {
    v1CryptoInternalPayinSession(input: $input, v1Context: $v1Context) {
      id
      ...PayinSessionFragment
    }
  }
  ${payinSessionFragment}
`;

export const payinSessionLazyQuery: PayinSessionLazyQueryDocument = doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const payinSessionLazyQueryOptions: V1LazyQueryOptionsWithoutVariables<PayinSessionLazyQueryDocument> =
  {
    fetchPolicy: 'no-cache',
  };

export default function usePayinSessionLazyQuery<
  THookVariables extends HookVariables<PayinSessionLazyQueryVariables> = {},
>(
  options: V1LazyQueryOptions<PayinSessionLazyQueryDocument, THookVariables>,
): V1LazyQueryReturn<PayinSessionLazyQueryDocument, THookVariables> {
  return useV1LazyQuery(payinSessionLazyQuery, {
    ...payinSessionLazyQueryOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type PayinSessionLazyQueryVariables = Exact<{
  input?: InputMaybe<OpenapiGetV1CryptoInternalPayinSessionInput>;
  v1Context: V1ContextInput;
}>;

export type PayinSessionLazyQueryData = {
  readonly __typename: 'Query';
  readonly v1CryptoInternalPayinSession: GraphQlFragmentUnion<
    {
      readonly __typename: 'OpenapiCryptocurrencyPayinsResourceCryptoPayinSession';
      readonly id: string;
    },
    [PayinSessionFragmentData]
  > | null;
};

export type PayinSessionLazyQueryToken = PayinSessionFragmentToken &
  AccountToken<{Query_v1CryptoInternalPayinSession: true}>;

export type PayinSessionLazyQueryDocument = GraphQlDocument<
  PayinSessionLazyQueryData,
  PayinSessionLazyQueryVariables,
  PayinSessionLazyQueryToken
>;
